import React from 'react';
import HyperLink from 'components/Core/HyperLink';

const RichTextHyperLink = ({ href, children, ...otherProps }) => {
  href = href || '';

  return href.startsWith('#') ? (
    <span id={href.substring(1, href.length)} {...otherProps}>
      {children}
    </span>
  ) : href.endsWith('nofollow') ? (
    <HyperLink href={href.replace(/#nofollow$/, '')} {...otherProps} rel="nofollow" target="_blank">
      {children}
    </HyperLink>
  ) : href.startsWith('title=') ? (
    <span {...otherProps}>{children}</span>
  ) : (
    <HyperLink href={href.startsWith('to=') ? href.split('=')[1] : href} {...otherProps}>
      {children}
    </HyperLink>
  );
};

export default RichTextHyperLink;
